import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "./api";

function AddTechnician() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    full_name: "",
    role: "",
    email: "",
  });

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.full_name || !formData.role || !formData.email) {
      alert("Please fill in all fields");
      return;
    }

    try {
      await api.post("/api/team", formData);
      alert("✅ Technician added!");
      navigate("/team");
    } catch (err) {
      console.error("❌ Error adding technician:", err);

      if (!err.response) {
        alert(`❌ Network/Server error:\n${err.message}`);
        return;
      }

      const msg =
        err.response?.data?.error ||
        err.response?.data?.message ||
        `HTTP ${err.response.status}`;

      alert(`❌ Failed to add technician: ${msg}`);
    }
  };

  return (
    <div className="main-content">
      <h1>➕ Add Technician</h1>

      <form onSubmit={handleSubmit}>
        <div>
          <label>Full Name:</label>
          <input
            name="full_name"
            value={formData.full_name}
            onChange={handleChange}
            required
          />
        </div>

        <div>
          <label>Role:</label>
          <input
            name="role"
            value={formData.role}
            onChange={handleChange}
            required
          />
        </div>

        <div>
          <label>Email:</label>
          <input
            name="email"
            type="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>

        <br />
        <button type="submit">Submit Technician</button>
      </form>
    </div>
  );
}

export default AddTechnician;
